import {
  ACKNOWLEDGEMENT_COPY_FAIL,
  ACKNOWLEDGEMENT_COPY_REQUEST,
  ACKNOWLEDGEMENT_COPY_SUCCESS,
  ACKNOWLEDGEMENT_DOWNLOAD_FAIL,
  ACKNOWLEDGEMENT_DOWNLOAD_REQUEST,
  ACKNOWLEDGEMENT_DOWNLOAD_SUCCESS,
  ACKNOWLEDGEMENT_EMAIL_FAIL,
  ACKNOWLEDGEMENT_EMAIL_REQUEST,
  ACKNOWLEDGEMENT_EMAIL_SUCCESS,
  ACKNOWLEDGEMENT_GENERATE_FAIL,
  ACKNOWLEDGEMENT_GENERATE_REQUEST,
  ACKNOWLEDGEMENT_GENERATE_SUCCESS,
  ACKNOWLEDGEMENT_PREVIEW_FAIL,
  ACKNOWLEDGEMENT_PREVIEW_REQUEST,
  ACKNOWLEDGEMENT_PREVIEW_SUCCESS,
  ACKNOWLEDGEMENT_RESET
} from '@/constants/acknowledgementConstants'

const initialState = {
  loading: false,
  error: null,
  generatedPDF: null,
  previewHTML: null,
  downloadURL: null,
  copiedPDF: null,
  emailResult: null,
  blobFileName: null // Store blob_file_name for subsequent operations
}

export const acknowledgementReducer = (state = initialState, action) => {
  switch (action.type) {
    // Generate Acknowledgement PDF
    case ACKNOWLEDGEMENT_GENERATE_REQUEST:
      return { ...state, loading: true, error: null, generatedPDF: null }
    case ACKNOWLEDGEMENT_GENERATE_SUCCESS:
      return {
        ...state,
        loading: false,
        generatedPDF: action.payload,
        blobFileName: action.payload.blob_file_name
      }
    case ACKNOWLEDGEMENT_GENERATE_FAIL:
      return { ...state, loading: false, error: action.payload }

    // Preview Acknowledgement (HTML)
    case ACKNOWLEDGEMENT_PREVIEW_REQUEST:
      return { ...state, loading: true, error: null, previewHTML: null }
    case ACKNOWLEDGEMENT_PREVIEW_SUCCESS:
      return { ...state, loading: false, previewHTML: action.payload }
    case ACKNOWLEDGEMENT_PREVIEW_FAIL:
      return { ...state, loading: false, error: action.payload }

    // Download Acknowledgement PDF
    case ACKNOWLEDGEMENT_DOWNLOAD_REQUEST:
      return { ...state, loading: true, error: null, downloadURL: null }
    case ACKNOWLEDGEMENT_DOWNLOAD_SUCCESS:
      return { ...state, loading: false, downloadURL: action.payload.download_url }
    case ACKNOWLEDGEMENT_DOWNLOAD_FAIL:
      return { ...state, loading: false, error: action.payload }

    // Copy Acknowledgement PDF
    case ACKNOWLEDGEMENT_COPY_REQUEST:
      return { ...state, loading: true, error: null, copiedPDF: null }
    case ACKNOWLEDGEMENT_COPY_SUCCESS:
      return { ...state, loading: false, copiedPDF: action.payload }
    case ACKNOWLEDGEMENT_COPY_FAIL:
      return { ...state, loading: false, error: action.payload }

    // Email Acknowledgement PDF
    case ACKNOWLEDGEMENT_EMAIL_REQUEST:
      return { ...state, loading: true, error: null, emailResult: null }
    case ACKNOWLEDGEMENT_EMAIL_SUCCESS:
      return { ...state, loading: false, emailResult: action.payload }
    case ACKNOWLEDGEMENT_EMAIL_FAIL:
      return { ...state, loading: false, error: action.payload }

    // Reset
    case ACKNOWLEDGEMENT_RESET:
      return initialState

    default:
      return state
  }
}
